<template>
  <div class="item collection-location" v-if="detail.type === 'CollectionLocation'">
    <h1 class="title is-4 has-text-centered">{{ detail.letter }} - {{ detail.name }}</h1>
  </div>

  <div class="item leg has-text-centered" v-else-if="detail.type === 'Leg'">
    <strong>{{ detail.duration.text }}</strong> <small>({{ detail.distance.text }})</small>
  </div>

  <div class="item leg has-text-centered" v-else-if="detail.type === 'PickupRequest'">
    <h1 class="title is-4 has-text-centered">{{ detail.letter }} - {{ detail.location.name }}</h1>
  </div>
</template>

<script>
export default {
  name: 'RouteDetail',

  props: ['detail']
}
</script>

<style lang="scss" scoped>
  .item {
    padding: .5rem 0;
  }
</style>

